import React, { useState } from "react";
import "./Nav.css";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");

  const links = [
    { href: "#",              label: "Home" },
    { href: "#about",         label: "About" },
    { href: "#services",      label: "Services" },
    { href: "#experience",    label: "Skills" },
    { href: "#portfolio",     label: "Projects" },
    { href: "#testimonials",  label: "Testimonials" },
    { href: "#highlights",    label: "Highlights" },
    { href: "#contact",       label: "Contact" },
  ];

  return (
    <nav className="main-nav">
      {links.map(({ href, label }) => (
        <a
          key={href}
          href={href}
          aria-label={label}
          className={activeNav === href ? "active" : ""}
          onClick={() => setActiveNav(href)}
        >
          <span className="nav-dot__label">{label}</span>
          <span className="nav-dot" />
        </a>
      ))}
    </nav>
  );
};

export default Nav;